export const trads =
{
	nl: {
		languages:
		{
			buttonDescription: 'Dutch',

		}, languagePage:
		{
			header1: 'Walraversyde',
			header2: 'ANNO 1465',

		}, landingPageTouwslagerij:
		{
			header1: 'TOUWSLAGERIJ',
			header2: '',
			subtitle: '',
			content: [
				'Voor zeilen, netten en ankers was veel touw nodig. Een vissersdorp als Walraversijde had dan ook een eigen touwslagerij. De touwslager spande lange strengen hennepvezels over houten stellages, draaide ze strak aan en vlocht ze in mekaar tot touw.',
				'Vlakbij laden mannen stenen kanonskogels op een kar. Vissersschepen hadden kanonnen aan boord om zich te verdedigen tegen piraten – of om zélf aan piraterij te doen.',
				'Aan de deur van een huis koopt een man enkele haringtonnen. Hij wil de tonnen gebruiken om er de wanden van een waterput mee te maken.'
			],
		}, landingPageKaatsbaan:
		{
			header1: 'KAATSBAAN',
			header2: '',
			subtitle: '',
			content: [
				'Een pleintje doet dienst als kaatsbaan. Het spel is net afgelopen. Kaatsen, een voorloper van tennis, was immens populair. Hier en daar werd het zelfs verboden omdat het te veel overlast veroorzaakte.',
				'Links van de kaatsbaan staat de herberg. In dorpsherbergen zoals deze kon je eten, drinken, elkaar ontmoeten en soms ook overnachten. De herbergier brouwde zijn bier zelf en bewaarde het in vaten.'
			],
		}, landingPageKapel:
		{
			header1: 'KAPEL',
			header2: '',
			subtitle: '',
			content: [
				'Schipbreuk, piraterij, ziekte… De vissersgemeenschap van Walraversijde stond bloot aan vele gevaren. De kapel bood steun en troost.',
				'Het gebouw was betaald door enkele rijke edelen uit de buurt. Toch bleef dit een kapel, geen kerk. Daardoor had het dorp ook geen eigen kerkhof: de inwoners werden begraven in Middelkerke.',
				'Tegenover de kapel hebben marktkramers hun waar uitgestald. Voor veel goederen hing Walraversijde af van de handel, die ook via de vissers verliep. Aan de rand van het dorp werd vee gehouden.'
			],
		}, landingPageMolen:
		{
			header1: 'MOLEN',
			header2: '',
			subtitle: '',
			content: [
				'Op een heuveltje, omringd door een gracht, staat de windmolen. Hier werd het graan gemalen om brood te bakken – hét basisvoedsel in die tijd. Walraversijde had verschillende bakkerijen, die tegelijk dienstdeden als visrokerij. ',
				'Overal in het dorp zijn mensen aan het werk. Een bakkersvrouw verkoopt brood aan een klant. Een wever maakt zeildoek van wol. En in de verte hoor je de geluiden van de schrijnwerker.',
				'Bij één huisje staat een weduwe met haar zoontje. Weduwen waren geen uitzondering in het dorp, want vissen op zee was levensgevaarlijk…'
			],
		}, landingPageVissers:
		{
			header1: 'VISSERS',
			header2: '',
			subtitle: '',
			content: [
				'Bijna alle inwoners verdienden direct of indirect de kost in de visserij. De reder is de eigenaar van verschillende schepen en nam een kapitein en vissers in dienst. Hij was een van de rijkste mannen van het dorp.',
				'De meeste mannen waren gewone vissers, met of zonder eigen schip. Ook aan wal hadden ze het druk. Ze hingen hun netten te drogen en herstelden ze. Ze smeerden hun gestreepte visserspakken in met olie, om ze waterdicht te houden. Of ze probeerden koopwaar te slijten die ze van overzee hadden meegebracht – van aardewerk tot granaatappels. '
			],
		}, credits:
		{
			content: 'Deze "tijdreis"-ervaring is het resultaat van een samenwerking tussen Atlantikwall Raversyde, de Provincie West-Vlaanderen en Timescope. Met de steun van Toerisme Vlaanderen en het Interreg Vlaanderen-Nederland project (Be)Leefbare Schelde.'
		}
	},
	en: {
		languages:
		{
			buttonDescription: 'English',

		}, languagePage:
		{
			header1: 'Walraversyde',
			header2: 'ANNO 1465',

		}, landingPageTouwslagerij:
		{
			header1: 'ROPERY',
			header2: '',
			subtitle: '',
			content: [
				'A lot of rope was needed for sails, nets, and anchors. A fishing village like Walraversijde had its own ropery. The ropemaker stretched long strands of hemp fibre over wooden frames, twisted them tightly, and braided them together to make rope.',
				'Nearby, men are loading stone cannonballs onto a cart. Fishing vessels had cannons on board to defend themselves against pirates – or to engage in piracy themselves. ',
				'At the door of a house, a man is buying a few herring barrels. He plans to use the barrels to form the walls of a well.'
			],
		}, landingPageKaatsbaan:
		{
			header1: '’JEU DE PAUME’',
			header2: '',
			subtitle: '',
			content: [
				'A square serves as a ‘jeu de paume’ court. The game has just ended. The ’jeu de paume’, an early precursor of tennis, was immensely popular. In some places, it was even banned because it caused too much disturbance.',
				'The inn stands to the left side of the court. In village inns like this one, people could eat, drink, meet each other, and sometimes even stay overnight. The innkeeper brewed his own beer and stored it in barrels.',
			],
		}, landingPageKapel:
		{
			header1: 'CHAPEL',
			header2: '',
			subtitle: '',
			content: [
				'Shipwreck, piracy, disease… The fishing community of Walraversijde was exposed to many dangers. The chapel provided support and comfort. ',
				'The building was funded by a few wealthy nobles from the area. However, it remained a chapel, not a church. As a result, the village did not have its own cemetery: the inhabitants were buried in Middelkerke.',
				'In front of the chapel, market vendors displayed their goods. Walraversijde depended on trade for many goods, which was also conducted through the fishermen. On the outskirts of the village, livestock was kept. '
			],
		}, landingPageMolen:
		{
			header1: 'MILL',
			header2: '',
			subtitle: '',
			content: [
				'On a small hill, surrounded by a moat, stands the windmill. This is where grain was ground to bake bread – the staple food of the time. Walraversijde had several bakeries, which also served as fish-smoking houses.',
				'All around the village, people are busy working. A baker\'s wife sells bread to a customer. A weaver makes sailcloth from wool. And in the distance, you can hear the sounds of the carpenter at work. ',
				'Near a small cottage, a widow stands with her young son. There were also widows in the village because fishing at sea was a deadly occupation…'
			],
		}, landingPageVissers:
		{
			header1: 'FISHERMEN',
			header2: '',
			subtitle: '',
			content: [
				'Almost all the inhabitants earned their living directly or indirectly from fishing. The shipowner owned several vessels and employed a captain and fishermen. He was one of the wealthiest men in the village. ',
				'Most men were simple fishermen, with or without their own boat. Even on land, they remained busy. They hung their nets out to dry and repaired them. They coated their striped fishing outfits with oil to make them waterproof. Or they tried to sell goods they had brought back from overseas – from pottery to pomegranates.',

			],
		}, credits:
		{
			content: 'This “time travel” experience is the result of a partnership between Atlantikwall Raversyde, the Province of West Flanders, and Timescope. With the support of Visit Flanders and Interreg Flanders Netherlands project (Be)Leefbare Schelde.'
		}
	},
	de: {
		languages:
		{
			buttonDescription: 'German',

		}, languagePage:
		{
			header1: 'Walraversyde',
			header2: 'ANNO 1465',

		}, landingPageTouwslagerij:
		{
			header1: 'SEILEREI',
			header2: '',
			subtitle: '',
			content: [
				'Für Segel, Netze und Anker wurde viel Tauwerk benötigt. Ein Fischerdorf wie Walraversijde hatte daher eine eigene Seilerei. Der Seilmacher spannte lange Hanffasern über hölzerne Gestelle, zog sie fest an und flocht sie zu Seilen zusammen.',
				'In der Nähe laden Männer steinerne Kanonenkugeln auf einen Karren. Fischerboote hatten Kanonen an Bord, um sich gegen Piraten zu verteidigen – oder um selbst Piraterie zu betreiben. ',
				'Vor der Tür eines Hauses kauft ein Mann einige Heringsfässer. Er möchte die Fässer nutzen, um daraus die Wände eines Brunnens zu bauen.'
			],
		}, landingPageKaatsbaan:
		{
			header1: '’JEU DE PAUME’',
			header2: '',
			subtitle: '',
			content: [
				'Ein Platz dient als ‘Jeu de Paume’ Spielfeld. Das Spiel ist gerade zu Ende gegangen. Das Ballspiel, ein Vorläufer des Tennis, war immens populär. Mancherorts wurde es sogar verboten, weil es zu viel Lärm verursachte. ',
				'Links vom Spielfeld steht das Wirtshaus. In Dorfgasthäusern wie diesem konnte man essen, trinken, sich treffen und manchmal auch übernachten. Der Wirt braute sein Bier selbst und lagerte es in Fässern.'
			],
		}, landingPageKapel:
		{
			header1: 'KAPELLE',
			header2: '',
			subtitle: '',
			content: [
				'Schiffbruch, Piraterie, Krankheit… Die Fischergemeinschaft von Walraversijde war vielen Gefahren ausgesetzt. Die Kapelle bot Unterstützung und Trost. ',
				'Das Gebäude wurde von einigen wohlhabenden Adligen aus der Umgebung finanziert. Dennoch blieb es eine Kapelle und keine Kirche.Daher hatte das Dorf auch keinen eigenen Friedhof: Die Einwohner wurden in Middelkerke begraben. ',
				'Gegenüber der Kapelle boten Markthändler ihre Waren an. Walraversijde war für viele Güter vom Handel abhängig, der auch über die Fischer lief. Am Rande des Dorfes wurde Vieh gehalten. '
			],
		}, landingPageMolen:
		{
			header1: 'MÜHLE',
			header2: '',
			subtitle: '',
			content: [
				'Auf einem kleinen Hügel, umgeben von einem Wassergraben, steht die Windmühle. Hier wurde das Getreide gemahlen, um Brot zu backen – das Grundnahrungsmittel jener Zeit. Walraversijde hatte mehrere Bäckereien, die gleichzeitig als Räuchereien für Fisch dienten.',
				'Überall im Dorf sind Menschen bei der Arbeit. Eine Bäckerin verkauft Brot an einen Kunden. Ein Weber stellt Segeltuch aus Wolle her. Und in der Ferne hört man die Geräusche des Schreiners. ',
				'Vor einem kleinen Haus steht eine Witwe mit ihrem Sohn. Auch Witwen lebten im Dorf, denn das Fischen auf hoher See war lebensgefährlich…'
			],
		}, landingPageVissers:
		{
			header1: 'FISCHER',
			header2: '',
			subtitle: '',
			content: [
				'Fast alle Einwohner verdienten ihren Lebensunterhalt direkt oder indirekt durch die Fischerei. Der Reeder ist Eigentümer mehrerer Schiffe und stellte einen Kapitän sowie Fischer ein. Er war einer der reichsten Männer im Dorf.',
				'Die meisten Männer waren einfache Fischer, mit oder ohne eigenes Schiff. Auch an Land hatten sie viel zu tun. Sie hängten ihre Netze zum Trocknen auf und reparierten sie. Sie bestrichen ihre gestreiften Fischeranzüge mit Öl, um sie wasserdicht zu machen. Oder sie versuchten, Waren zu verkaufen, die sie aus Übersee mitgebracht hatten – von Keramik bis zu Granatäpfeln. '
			],
		}, credits:
		{
			content: 'Diese „Zeitreise“- Erfahrung ist das Ergebnis einer Partnerschaft zwischen Atlantikwall Raversyde, der Provinz Westflandern und Timescope. Mit der Unterstützung von Visit Flanders und dem Interreg Flandern- Niederlande - Projekt (Be)Leefbare Schelde.'
		}
	},
	fr: {
		languages:
		{
			buttonDescription: 'Français',

		}, languagePage:
		{
			header1: 'Walraversyde',
			header2: 'ANNO 1465',

		}, landingPageTouwslagerij:
		{
			header1: 'CORDERIE',
			header2: '',
			subtitle: '',
			content: [
				'Pour les voiles, les filets et les ancres, une grande quantité de cordage était nécessaire. Un village de pêcheurs comme Walraversijde possédait donc sa propre corderie. Le cordier tendait de longues fibres de chanvre sur des cadres en bois, les tordait fermement et les tressait ensemble pour former des cordes.',
				'Non loin de là, des hommes chargent des boulets de canon en pierre sur une charrette. Les bateaux de pêche étaient équipés de canons pour se défendre contre les pirates – ou pour pratiquer eux-mêmes la piraterie. ',
				'Devant la porte d\'une maison, un homme achète quelques tonneaux de hareng. Il souhaite les utiliser pour former les parois d’un puit.'
			],
		}, landingPageKaatsbaan:
		{
			header1: 'JEU DE PAUME',
			header2: '',
			subtitle: '',
			content: [
				'Une petite place sert de terrain de jeu pour le jeu de paume. La partie vient de se terminer. Le jeu de paume, un ancêtre du tennis, était extrêmement populaire. À certains endroits, il fut même interdit en raison des nuisances qu’il engendrait. ',
				'À gauche du terrain se trouve l’auberge. Dans des auberges de village comme celle-ci, on pouvait manger, boire, se rassembler et parfois même passer la nuit. L’aubergiste brassait lui-même sa bière et la conservait dans des tonneaux.'
			],
		}, landingPageKapel:
		{
			header1: 'CHAPELLE',
			header2: '',
			subtitle: '',
			content: [
				'Naufrage, piraterie, maladie… La communauté de pêcheurs de Walraversijde était exposée à de nombreux dangers. La chapelle offrait soutien et réconfort',
				'Le bâtiment a été financé par quelques riches nobles de la région. Pourtant, il s’agissait bien d’une chapelle et non d’une église. Par conséquent, le village ne possédait pas son propre cimetière : les habitants étaient enterrés à Middelkerke.',
				'En face de la chapelle, des marchands ambulants exposaient leurs marchandises. Pour de nombreux biens, Walraversijde dépendait du commerce, qui passait également par les pêcheurs. À la périphérie du village, on élevait du bétail. '
			],
		}, landingPageMolen:
		{
			header1: 'MOULIN',
			header2: '',
			subtitle: '',
			content: [
				'Sur une petite colline, entouré d’un fossé, se dresse le moulin à vent. C’est ici que le grain était moulu pour fabriquer du pain – l’aliment de base de l’époque. Walraversijde comptait plusieurs boulangeries, qui faisaient également office de fumoirs à poisson. ',
				'Partout dans le village, les habitants s’activent. Une boulangère vend du pain à un client. Un tisserand fabrique de la toile à voile en laine. Et au loin, on entend les bruits du menuisier à l’œuvre.',
				'Près d’une maisonnette, une veuve se tient avec son fils. Le village comptait aussi des veuves, car partir pêcher en mer était extrêmement dangereux…'
			],
		}, landingPageVissers:
		{
			header1: 'PÊCHEURS',
			header2: '',
			subtitle: '',
			content: [
				'Presque tous les habitants gagnaient leur vie, directement ou indirectement, grâce à la pêche. L\'armateur était propriétaire de plusieurs navires et employait un capitaine ainsi que des pêcheurs. Il faisait partie des hommes les plus riches du village. ',
				'La plupart des hommes étaient de simples pêcheurs, avec ou sans leur propre bateau. Même à terre, ils restaient occupés. Ils faisaient sécher leurs filets et les réparaient. Ils enduisaient leurs habits de pêche rayés d’huile pour les rendre imperméables. Ou bien ils tentaient de vendre des marchandises rapportées d’outre-mer – de la poterie aux grenades. '
			],
		}, credits:
		{
			content: 'Cette expérience de « voyage dans le temps » est le fruit d’un partenariat entre Atlantikwall Raversyde, la Province de Flandre - Occidentale et Timescope. Avec le soutien de Visit Flanders et du projet Interreg Flandre - Pays-Bas (Be)Leefbare Schelde.'
		}
	},
}; 